import 'reflect-metadata'
import HandicappingModel from "@models/handicap";
import BaseComponent from '@base/component'
import { createApp, defineComponent } from "vue";
import moment from 'moment'
import { makeUrl } from "@utils/query";
import DataTable, { Api } from "datatables.net-dt";
import ErrorsComponentVue from '@components/errors/errors.vue'
import MsgsComponentVue from '@components/msgs/msgs.vue'

function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

var model = new HandicappingModel();

var component = defineComponent({
    mixins: [BaseComponent],
    components: {
        errors: ErrorsComponentVue,
        msgs: MsgsComponentVue
    },    
    data: function () {
        var table:Api<any> = {} as any;
        model.on("error", this.showError, this);
        model.fetchData();
        return { model, table }
    },
    mounted: function() {
        this.table = new DataTable("#tipsTable", {
            "language": {
                "emptyTable": "No handicapping entries in table."
            },
            pageLength: 25,
            "order": [[2, "desc"]],
            columns: [{
                    "className": 'details-control',
                    "data": "_id",
                    type: "string",
                    visible: false
                },
                { data: "title", type: "string" },
                { data: "publishedDate", type: "date", render: data => moment(data).format('MMM Do') },
                {
                    data: null, defaultContent: "", render: data => {
                        var str = [];
                        if (data.sheet.pdf && data.sheet.pdf.filename) {
                            str.push('<a href="' + makeUrl(`/tipsheets/sheet/${encodeURIComponent(data.sheet.pdf.filename)}`) + '">Download</a>');
                        }
                        if (str.length > 1)
                            return str.join(" / ");
                        else return str.join("");
                    }
                }
            ],
            "ajax": {
                url: document.location.href,
                data: (d) => {
                    if ($("#curDate").length == 0) {
                        $("<div class='dataTables_filter' style='margin-left:10%;display:inline'><label>Date Select:<input type='text' id='curDate' /></label></div>").insertAfter("#tipsTable_length");
                        $("#curDate").datepicker();

                        var dt = new Date();
                        var month = pad((dt.getMonth() + 1), 2, '0');
                        var day = pad(dt.getDate(), 2, '0');
                        var yr = dt.getFullYear().toString();
                        var currentDate = month + "/" + day + "/" + yr;
                        //$("#curDate").val(currentDate);
                        $("#curDate").change(() => {
                            (this.table as Api<any>).ajax.reload();
                            $("#curDate").datepicker("hide");
                        });
                    }
                    else {
                        (d as any).curDate = $("#curDate").val();
                    }
                }
            },
            "processing": true,
            "serverSide": true,
            "rowCallback": (nRow, aData, iDisplayIndex) => {
            },
            "drawCallback": () => {
                
            }
        });        
    },
    methods: {
        reloadTable: function () {
            if (this.table) {
                this.table.ajax.reload();
            }
        }
    }
});

model.fetchData().then(data => {
    const app = window.app = createApp(component) 
    app.mount(".handicapping-detail")
});
